import { GridRowSelectionModel } from "@mui/x-data-grid";

import { AppointmentForTakeoverResponse } from "@/api";
import { DataTable } from "@/common/components/table/DataTable";
import { useCurrentUserContext } from "@/common/contexts/current-user-context/CurrentUserContext";
import { TakeoverView } from "@/pages/takeover/Takeover.types";

import { useTakeoverColumns } from "./hooks/useTakeoverColumns";

const ROW_HEIGHT = 48;
const COLUMN_HEADER_HEIGHT = 56;

interface Props {
  appointments: AppointmentForTakeoverResponse[];
  view: TakeoverView;
  isBusy: boolean;
  isLoading: boolean;
  selectionModel: GridRowSelectionModel;
  onSelectionModelChange: (selectionModel: GridRowSelectionModel) => void;
  paginationResetKey: string;
  onTakeOver: (row: AppointmentForTakeoverResponse) => void;
  onReverse: (row: AppointmentForTakeoverResponse) => void;
  onMark: (row: AppointmentForTakeoverResponse) => void;
  onUnmark: (row: AppointmentForTakeoverResponse) => void;
}

/** Flat table of takeover appointments, ordered by date ascending, with a gray header row. */
export function TakeoverBoard({
  appointments,
  view,
  isBusy,
  isLoading,
  selectionModel,
  onSelectionModelChange,
  paginationResetKey,
  onTakeOver,
  onReverse,
  onMark,
  onUnmark,
}: Props) {
  const { currentUser } = useCurrentUserContext();

  // Checkbox selection feeds the header's bulk actions, which only the release tab offers.
  const allowSelection = view === "toRelease";

  const columns = useTakeoverColumns({
    view,
    currentCounselorId: currentUser.counselorId,
    isBusy,
    onTakeOver,
    onReverse,
    onMark,
    onUnmark,
  });

  return (
    <DataTable
      data={appointments}
      columns={columns}
      getRowId={(row) => row.appointmentId}
      isLoading={isLoading}
      rowHeight={ROW_HEIGHT}
      columnHeaderHeight={COLUMN_HEADER_HEIGHT}
      initialSortModel={[{ field: "startTimeUtc", sort: "asc" }]}
      checkboxSelection={allowSelection}
      rowSelectionModel={selectionModel}
      onRowSelectionModelChange={onSelectionModelChange}
      disableColumnMenu
      paginationResetKey={paginationResetKey}
    />
  );
}
